import React from "react";
import "../../../css/Praplanning/ParaplanningFields.css";

const ParaplanningInputField = ({
  label,
  required = false,
  value = "",
  onChange,
  placeholder = "",
  type = "text",
  name,
  disabled = false,
  error = "",
  className = "",
}) => {
  return (
    <label className="ParaplanningField">
      {label && (
        <span className="ParaplanningField__Label FP_Body">
          {label}
          {required && <span className="ParaplanningField__Required">*</span>}
        </span>
      )}

      <input
        className={`ParaplanningField__Input FP_Content black ${className} ${
          error ? "ParaplanningField__Input--Error" : ""
        }`}
        type={type}
        name={name}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
        required={required}
      />

      {error && <span className="ParaplanningField__Error">{error}</span>}
    </label>
  );
};

export default ParaplanningInputField;